import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageEditText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageEditText"><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V12.6674C18.6206 12.1667 17.0152 12.4694 15.909 13.5756L11.5 17.9846V22H4ZM8 6H16V7.5H8V6ZM8 10V11.5H12V10H8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M16.9697 14.6363C17.9069 13.699 19.4264 13.699 20.3637 14.6363C21.3009 15.5735 21.3009 17.093 20.3637 18.0303L16.394 21.9999H13V18.6059L16.9697 14.6363Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageEditText;
